import { createContext, useEffect, useReducer } from 'react';
import { fullPageWrapperHandlers, fullPageWrapperInitialState, fullPageWrapperReducer } from '../reducers/FullPageWrapperReducer';

/** AppContext */
export const FullPageWrapperContext = createContext();

/** Global OtherDatas for the Event */
const FullPageWrapperProvider = (props) => {

  const fullPageWrapper_initState = {}
  const [fullPageWrapper_state, fullPageWrapper_dispatch] = useReducer(fullPageWrapperReducer, fullPageWrapperInitialState(fullPageWrapper_initState));
  const fullPageWrapper_handlers = fullPageWrapperHandlers(fullPageWrapper_dispatch, fullPageWrapper_state)

  const providerContext = () => <FullPageWrapperContext.Provider
    value={{ fullPageWrapper_state, fullPageWrapper_handlers }}>
    {props.children}
  </FullPageWrapperContext.Provider>

  return providerContext()
}

export default FullPageWrapperProvider